import { css } from '@emotion/css';

import { Color } from '../../../../../../styles';

export const alignCenter = css`
  text-align: center;
`;

export const filterStyling = css`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: ${Color.BRAND.BRAND4};
  cursor: pointer;
`;

export const activeFilter = css`
  color: ${Color.BRAND.BRAND6};
`;

export const negativeValue = css`
  color: ${Color.RED.RED6};
`;

export const pozitiveValue = css`
  color: ${Color.GREEN.GREEN8};
`;

export const totalTextDetail = css`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: ${Color.GRAYSCALE.GRAY8};
`;
